import alt from "../alt";

class GlobalNotificationActions {
  constructor() {
    this.generateActions("notify", "close");
  }
}

export default alt.createActions(GlobalNotificationActions);



// WEBPACK FOOTER //
// ./src/app/actions/GlobalNotificationActions.js